/** declare only http service related requests */

import { HttpTokens, DeleteAttendeeFile } from '@/src/types';
import { AxiosService } from '@/utils/axios';
import { AxiosResponse } from 'axios';
import { DEFAULT_HTTP_TIMEOUT } from '../..';

/**
 * @description delete attendee file by id
 * @param prefix only partial url, base url already prefixed
 * @param {boolean?} hardRejection when soft error is enabled it will return response from .then, and not catch it again, just so you know
 */
export const AttendeeDeleteFile = (
  prefix: string = 'training/attendee/remove-file',
  id: string,
  tokens: HttpTokens,
  hardRejection = true
): Promise<DeleteAttendeeFile> => {
  /** provide higher timeout for upload */
  const instance = new AxiosService({ method: 'delete', timeout: DEFAULT_HTTP_TIMEOUT, apiRef: prefix, proxyType: 'LOCAL_PROXY' }, true, hardRejection);

  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...(tokens.jwt ? { Authorization: 'Bearer ' + tokens.jwt } : {}),
    },
  };

  return instance.client
    .delete(`${prefix}/${id}`, config)
    .then((d: AxiosResponse<DeleteAttendeeFile>) => {
      return d.data;
    })
    .catch(instance.defaultHandleError) as Promise<DeleteAttendeeFile>;
};
